import AxiosConfig from "./AxiosConfig";

const fetchGetEntreprises = async (queryParams) => {
    const url = queryParams ? `/admin/entreprises${queryParams}` : '/admin/entreprises';
    try {
        const response = await AxiosConfig.get(url);

        if (response.data.success) {
            return response.data;
        } else {
            return { success: false, message: "erreur " };
        }
    } catch (error) {
        console.error('error', error);
    }
}

const fetchSetEntrepriseActif = async (entreprise) => {
    try {
        const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/actif`, {"actif": !entreprise.actif});
        return response.data;
    } catch (error) {
        console.error('error', error);
        return { success: false, message: error };
    }
}

const fetchGetEntreprisesWithContratBetweenDates = async (start, end) => {
    try {
        const response = await AxiosConfig.get(`/admin/entreprises_with_contrat_between_dates?start=${start}&end=${end}`);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('error', error);
        return { success: false, message: error };
    }
}

const fetchGetEntreprise = async (entrepriseId) => {
    try {
        const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}`);
        return response.data;
    } catch (error) {
        console.error('error', error);
        return { success: false, message: error };
    }
}

const fetchToSetContratActif = async (contrat) => {
    try {
        const response = await AxiosConfig.post(`/admin/entreprises/${contrat.entreprise.id}/contrats/${contrat.id}/actif`, {"actif": !contrat.actif});
        return { success: true, data: response.data };
    } catch (error) {
        console.error('error', error);
        return { success: false, message: error };
    }
}

const fetchGetContrats = async (entrepriseId) => {
    try {
        const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats`);

        return { success: true, data: response.data.myContrats };
    } catch (error) {
        console.error('error', error);
    }
}

const getEntrepriseWithToken = async (token, uid) => {
    try {
        const response = await AxiosConfig.get(`/entreprises/get_entreprise/token/${token}/${uid}`);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des données de l\'entreprise :', error);
        return {success: false, message: error};
    }
}

const fetchEntreprisesSelect = async () => {
    try {
        const response = await AxiosConfig.get(`/entreprises/select`);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des données de l\'entreprise :', error);
        return {success: false, message: error};
    }
}

export {
    fetchGetEntreprises,
    fetchSetEntrepriseActif,
    fetchGetEntreprisesWithContratBetweenDates,
    fetchGetEntreprise,
    fetchGetContrats,
    fetchToSetContratActif,
    getEntrepriseWithToken,
    fetchEntreprisesSelect
};